import * as yup from "yup";
import * as moment from "moment";
import cardValidator from 'card-validator';

const today = new Date();

//Schema YUP
export const additionalExpenceValidationSchema = [
  //validation for step1
  yup.object({
    cards: yup.array().of(
      yup.object().shape({
        billingAddress: yup.string(),
        cardNumber: yup
          .string("Card Number is required")
          .required("Card Number is required")
          // .min(19, "Must be exactly 3 digits"),
          /*.test("len", "Must be exactly 16 digits", (val) => {
            return val.replace(/\s/g, "").length > 15;
          })*/
          .test('test-number', 'Card Number is invalid',
            value => value.indexOf('-') !== -1 ? true : cardValidator.number(value).isValid
          ),
        cardHolderName: yup.string().required("Card Holder Name is required"),
        expirationDate: yup
          .date()
          .transform((value, rawValue) => {
            let correctDate = moment(rawValue, ["yyyy-mm-dd", "ddd MMM DD Y"]).toDate();
            return correctDate;
          })
          .min(today, "Date should be later than today!")
          .nullable()
          .required("Expiration Date is required"),
        cvv: yup
          .string("CVV is required")
          .required("CVV is required")
          // .matches(cvvRegex, "Must be only digits")
          .when('cardNumber', {
            is: (value) => value.indexOf('-') !== -1,
            then: yup.string().matches(/^[0-9*●]+$/, "Must be only digits"),
            otherwise: yup.string().matches(/^[0-9]+$/, "Must be only digits"),
          })
          .min(3, "Must be exactly 3 or 4 digits")
          .max(4, "Must be exactly 3 or 4 digits"),
        country: yup.string().when("billingAddress", {
          is: (val) => val !== "default",
          then: yup.string().required('Country Name is required"'),
          otherwise: yup.string(),
        }),
        city: yup.string().when("billingAddress", {
          is: (val) => val !== "default",
          then: yup.string().required('City Name is required"'),
          otherwise: yup.string(),
        }),
        state: yup.string().when("billingAddress", {
          is: (val) => val !== "default",
          then: yup.string().required('State Name is required"'),
          otherwise: yup.string(),
        }),
        street: yup.string().when("billingAddress", {
          is: (val) => val !== "default",
          then: yup.string().required('Street Name is required"'),
          otherwise: yup.string(),
        }),
        postalCode: yup.string().when("billingAddress", {
          is: (val) => val !== "default",
          then: yup.string().required('Zip/Postal Code is required"'),
          otherwise: yup.string(),
        }),
        cardHolderEmail: yup.string().when("billingAddress", {
          is: (val) => val !== "default",
          then: yup
            .string()
            .email("Card Holder Email is required")
            .required("Card Holder Email is required"),
          otherwise: yup.string(),
        }),
        cardPhoneNumber: yup.string().when("billingAddress", {
          is: (val) => val !== "default",
          then: yup
            .string(),
          // .min(16, "Must be min 8 digits")
          // .max(22, "Must be max 15 digits"),
          otherwise: yup.string(),
        }),
        // country: yup.string().required("Country Name is required"),
        // city: yup.string().required("City Name is required"),
        // state: yup.string().required("State Name is required"),
        // street: yup.string().required("Street Name is required"),
        // postalCode: yup.string().required("Zip/Postal Code is required"),
        // cardHolderEmail: yup
        //   .string()
        //   .email("Card Holder Email is required")
        //   .required("Card Holder Email is required"),
        // cardPhoneNumber: yup
        //   .string()
        //   .min(16, "Must be min 8 digits")
        //   .max(22, "Must be max 15 digits"),
      })
    ),
    cardsAmmount: yup.array().of(yup.number()),
    confirmTerms: yup
      .boolean()
      .required(
        "You must confirm our Terms, Conditions and Privacy Policy acceptance"
      )
      .oneOf(
        [true],
        "You must confirm our Terms, Conditions and Privacy Policy acceptance"
      ),
  }),
  //validation for step 2 (Loading, please wait...)
  yup.object({}),
  //validation for step 3 (Thank you for booking with %project name%)
  yup.object({}),
];
